import { useQuery } from '@tanstack/react-query';

import axios from 'axios';

import { SystemLog } from 'types';

export const getSystemLogs = async (
  categoryId: number | undefined,
  fromDate: string | undefined,
  toDate: string | undefined
): Promise<SystemLog[]> => {
  const url = '/api/system-logs';
  const query = {
    params: {
      fromDate,
      toDate,
      categoryId:
        categoryId !== undefined && categoryId !== -1 ? categoryId : undefined,
    },
  };
  const { data } = await axios.get(url, query);
  return data as SystemLog[];
};

export const useSystemLogs = <T extends any = SystemLog[]>(
  categoryId: number | undefined,
  fromDate: string | undefined,
  toDate: string | undefined,
  select?: (data: SystemLog[]) => T
) => {
  return useQuery({
    queryKey: ['systemLogs', categoryId, fromDate, toDate],
    queryFn: () => getSystemLogs(categoryId, fromDate, toDate),
    select: select,
    // Refresh query results every minute
    staleTime: 60 * 1000,
  });
};
